import * as React from 'react';
import './CancelOrderModalMobile.scss';
import accounting from 'accounting';
import Select2 from 'src/components/common/Select2';
import SlideMenu from 'src/components/common/SlideMenu';
import OrderLineModel from 'src/model/orderline.model';
import PartReturnModel from 'src/model/partReturn.model';
import { ISelectOption } from 'src/components/common/Select2/components/SelectOption/SelectOption';
import i18n from 'src/translation/i18n';

export interface ICancelOrderModalMobileProps {
  order: OrderLineModel[] | PartReturnModel;
  poNumber: string;
  date: string;
  showSlideMenu: boolean;
  //   handleShowHideModal: () => void;
  onSubmitCancellation: (order: OrderLineModel[] | PartReturnModel) => void;
  onCloseSlideMenu: () => void;
  t?: any;
}

export interface ICancelOrderModalMobileState {
  selectedReason: ISelectOption;
  comments: string;
  optionsError: boolean;
}

class CancelOrderModalMobile extends React.Component<
  ICancelOrderModalMobileProps,
  ICancelOrderModalMobileState
> {
  constructor(props: ICancelOrderModalMobileProps) {
    super(props);
    this.state = {
      selectedReason: null,
      comments: '',
      optionsError: false
    };
  }

  private hideSlideMenu = () => {
    this.setState({ optionsError: false });
    return this.props.onCloseSlideMenu();
  };

  private handleSelectReason = (selectedReason: ISelectOption) => {
    this.setState({ selectedReason });
  };

  private handleCommentsChange = (comments: string) => {
    this.setState({ comments });
  };

  private onSubmitCancellation = () => {
    if (!this.state.selectedReason) {
      this.setState({ optionsError: true });
      return;
    }
    this.setState({ optionsError: false });
    this.props.onSubmitCancellation(this.props.order);
    this.props.onCloseSlideMenu();
  };

  private renderCancelOrden = (order: OrderLineModel[]) => {
    const { t } = this.props;
    if (order) {
      return order.map((details, idx) => {
        return (
          <div key={idx} className="description-row">
            <div className="data-container">
              <span className="header">{t('myReturns.partNo')}</span>
              <p className="order--part-number">{`${details.manufacturerCode} ${details.productNumber}`}</p>
            </div>
            <div className="data-container">
              <span className=" header qty">{t('myOrders.qty')}</span>
              <p className="qty">{details.quantity}</p>
            </div>
            <div className="data-container">
              <span className="header">{t('myOrders.price')}</span>
              <p>{accounting.formatMoney(details.price)}</p>
            </div>
            <div className="data-container">
              <span className="header">{t('myOrders.amount')}</span>
              <p>{accounting.formatMoney(details.amount)}</p>
            </div>
          </div>
        );
      });
    }
    return '';
  };

  private renderCancelItem = (item: PartReturnModel) => {
    const { t } = this.props;
    if (item) {
      return (
        <div className="description-row">
          <div className="data-container">
            <span className="header">{t('myReturns.partNo')}</span>
            <p className="order--part-number">{`${item.manufacturerCode} ${item.productNumber}`}</p>
          </div>
          <div className="data-container">
            <span className=" header qty">{t('myOrders.qty')}</span>
            <p className="qty">{item.quantity}</p>
          </div>
          <div className="data-container">
            <span className="header">{t('myOrders.price')}</span>
            <p>{accounting.formatMoney(item.price)}</p>
          </div>
          <div className="data-container">
            <span className="header">{t('myOrders.amount')}</span>
            <p>{accounting.formatMoney(item.amount)}</p>
          </div>
        </div>
      );
    }
    return '';
  };

  private renderModalType() {
    const { order } = this.props;
    if (Array.isArray(order)) {
      return this.renderCancelOrden(order);
    } else {
      return this.renderCancelItem(order);
    }
  }

  private renderOrdenHeader = (order: OrderLineModel[]) => {
    const { date, poNumber, t } = this.props;
    return (
      <div className="rp-order-cancellation-modal-mobile-order-info">
        <div className="rp-order-cancellation-modal-mobile-order-info-data">
          {t('myOrders.searchByKeys.orderNumber')}:{' '}
          <p className="data-text">{order[0].orderNumber}</p>
        </div>
        <div className="rp-order-cancellation-modal-mobile-order-info-data">
          {t('myOrders.orderDate')}: <p className="data-text">{date}</p>
        </div>
        <div className="rp-order-cancellation-modal-mobile-order-info-data">
          {t('myReturns.pONumber')}: <p className="data-text">{poNumber}</p>
        </div>
      </div>
    );
  };

  private renderItemHeader = (item: PartReturnModel) => {
    const { date, poNumber, t } = this.props;
    return (
      <div className="rp-order-cancellation-modal-mobile-order-info">
        <div className="rp-order-cancellation-modal-mobile-order-info-data">
          {t('myOrders.searchByKeys.orderNumber')}:
          <p className="data-text">{item.orderNumber}</p>
        </div>
        <div className="rp-order-cancellation-modal-mobile-order-info-data">
          {t('myOrders.orderDate')}:<p className="data-text">{date}</p>
        </div>
        <div className="rp-order-cancellation-modal-mobile-order-info-data">
          {t('myReturns.pONumber')}: <p className="data-text">{poNumber}</p>
        </div>
      </div>
    );
  };

  private renderModalHeader() {
    const { order } = this.props;
    if (order) {
      if (Array.isArray(order)) {
        return this.renderOrdenHeader(order);
      } else {
        return this.renderItemHeader(order);
      }
    }
    return '';
  }

  public render() {
    const { t } = this.props;
    const options = [
      {
        name: `${i18n.t('myOrders.orderCreatedByMistake')}`,
        value: 'order created by mistake'
      },
      {
        name: `${i18n.t('myOrders.myCustomerCancelled')}`,
        value: 'my customer cancelled'
      },
      { name: `${i18n.t('myOrders.notInStock')}`, value: 'not in stock' },
      {
        name: `${i18n.t('myOrders.noEtaArrive')}`,
        value: 'No ETA/ item(s) would not arrive on time'
      },
      {
        name: `${i18n.t('myOrders.itemPriceHigh')}`,
        value: 'Item price too high'
      },
      {
        name: `${i18n.t('myOrders.shipCostHigh')}`,
        value: 'Shipping cost too high'
      },
      {
        name: `${i18n.t('myOrders.foundCheaper')}`,
        value: 'Found cheaper somewhere else'
      },
      { name: `${i18n.t('myOrders.other')}`, value: 'other' }
    ];
    return (
      <SlideMenu
        mounted={this.props.showSlideMenu}
        goBackTitle={i18n.t('common.back')}
        level={2 + 30}
        handleCloseMenu={this.hideSlideMenu}
      >
        <div className="rp-order-cancellation-modal-mobile">
          <div className="rp-order-cancellation-modal-mobile-content">
            <div className="title">Order to Cancel</div>
            {this.renderModalHeader()}
            <div className="rp-order-cancellation-modal-mobile-order-reason">
              <label>{t('common.cancellationReason')}:*</label>
              <div onClick={() => this.setState({ optionsError: false })}>
                <Select2
                  label=""
                  options={options}
                  selected={this.state.selectedReason}
                  placeholder="Select a Cancellation reason"
                  onSelect={sel => this.handleSelectReason(sel)}
                  className={'cancellation-reason-options'}
                  onError={this.state.optionsError}
                />
              </div>
            </div>
            <div className="rp-order-cancellation-modal-mobile-order-comments">
              <label>{t('feedbackForm.comments')}:</label>
              <textarea
                className="rp-order-cancellation-modal-mobile-order-textarea"
                value={this.state.comments}
                onChange={e => this.handleCommentsChange(e.target.value)}
                rows={8}
                required={true}
              />
            </div>
            <div className="rp-order-cancellation-modal-mobile-orders-table">
              <div className="orders-description">{this.renderModalType()}</div>
            </div>
          </div>
          <div className="rp-order-cancellation-modal-mobile-order-actions">
            <button
              className="submit-action"
              onClick={this.onSubmitCancellation}
            >
              {t('common.submitCancellation')}
            </button>
          </div>
        </div>
      </SlideMenu>
    );
  }
}

export default CancelOrderModalMobile;
